import request from '@/utils/request'
//import storage from '@/utils/storage'
const route_factory = `/motor/getmotorfactorylist`
const route_type = `/motor/getmotortypelist`
const route_reducer = '/reducer/getreducerseriesnamelist'
const route_ratio = '/reducer/getreductionratiolist'
const route_available = '/reducer/getlistbyseriesandmotor'
const route_reducersize = '/reducer/getreducerinfo'
const route_factorysize  = '/motor/getmotorinfo'

const route_picture = '/reducer/getpicture' //获取图片接口

export function getPicUrl(data) {
  return request.get(route_picture,{
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      reducer_series_name : data
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

// 获取马达厂商列表

export function getmotorfactorylist() {
  return request.get(route_factory, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 获取马达电机型号列表
export function getmotortypelist(data) {
  return request.get(route_type, {
    headers:{
      'Content-Type': 'application/json'
    },
    params:{
      motor_factory: data
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 获取减速机系列列表
export function getreducerlist() {
  return request.get(route_reducer, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 获取系列减速比列表
export function getratiolistt(data) {
  return request.get(route_ratio, {
    headers:{
      'Content-Type': 'application/json'
    },
    params:{
      reducer_series_name: data
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过前面参数获取可用的减速机型号
export function getlistbyseriesandmotor(data) {
  var lang = localStorage.getItem('lang');
  data.lang = lang
  return request.post(route_available, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过减速机型号获取减速尺寸详情
export function getinfobyreducersize(data) {
  return request.post(route_reducersize, data,{
    headers:{
      'Content-Type': 'application/json'
    }/* ,
    params:{
      reducer_size: data.reducer_size[0]
    } */
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过减速机型号得到减速机的所有参数
export function getinfobyfactoryandsize(data) {
  const params = {};
  params.motor_factory = data.motor_factory;
  params.motor_type = data.motor_type;
  return request.post(route_factorysize, params,{
    headers:{
      'Content-Type': 'application/json'
    }/* ,
    params:{
      motor_factory: data.motor_factory,
      motor_type: data.motor_type
    } */
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}



// WEBPACK FOOTER //
// ./src/store/electric_motor.js